import {
  type MobileDevice,
  type Group,
} from '@reliance/types/models/MobileDevice';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export const mobileDevice = (siteApi: ApiService) => ({
  index: (orderBy: string): Promise<PaginatedResponse<MobileDevice>> => {
    return siteApi.get<PaginatedResponse<MobileDevice>>('/mobile-device', {
      params: {
        includeInmates: true,
        orderBy,
        applications: 'Connect - Messaging',
        perPage: 1000,
      },
    });
  },
  getAvailable: (): Promise<PaginatedResponse<MobileDevice>> => {
    return siteApi.get('/mobile-device', {
      params: {
        excludeInmateAssigned: true,
        orderBy: 'name',
        applications: 'Connect - Messaging',
        perPage: 1000,
      },
    });
  },
  resetAppLock: (ids) => {
    return siteApi.put(`/mobile-device/${ids.join(',')}/reset-app-lock`);
  },
  put: (ids, data) => {
    return siteApi.put(`/mobile-device/${ids.join(',')}`, data);
  },
  group: {
    index: (params = {}): Promise<PaginatedResponse<Group>> => {
      return siteApi.get('/mobile-device/group', { params });
    },
  },
});
